import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { RootContext } from "@-/dev.improve.haniverse.routes._context";

export function useLessonPageStrokeViewSize() {
  const [orientation, windowDimensions] = useContextSelectors(
    RootContext,
    (c) => c.orientation,
    (c) => c.windowDimensions,
  );
  const { height, width } = windowDimensions;
  const isLandscape = orientation === "landscape";

  return isLandscape ? Math.min(width / 2 - 80, height - 120, 360) : Math.min(width - 80, 280);
}
